import React, { useState } from 'react';
import { ButtonContainer, InputWrapper, StyledInput } from './styles';
import { CommonButton } from '@Components';

interface IProps {
  placeholder: string;
  buttonText: string;
  minLimitToActivateCTA: number;
  handleApply: (value: string) => void;
}

const InputApplyTextfield: React.FC<IProps> = (props) => {
  const { placeholder, buttonText, minLimitToActivateCTA = 2, handleApply } = props;
  const [value, setValue] = useState('');
  const [disabled, setDisabled] = useState(true);

  const handleChange = (e: any) => {
    if (e.target.value.length >= minLimitToActivateCTA) setDisabled(false);
    else setDisabled(true);
    setValue(e.target.value);
  };

  return (
    <InputWrapper>
      <StyledInput type="text" placeholder={placeholder} value={value} onChange={handleChange} />
      <ButtonContainer>
        <CommonButton
          text={buttonText}
          type="link"
          onClick={() => handleApply(value)}
          disabled={disabled}
        />
      </ButtonContainer>
    </InputWrapper>
  );
};

export default InputApplyTextfield;
